import {Dispatch, SetStateAction, forwardRef, useEffect, useRef, useState} from 'react';
import Select, { SelectInstance } from 'react-select';

interface UserSelectProps {
 	isVisible: boolean;
 	setIsVisible:Dispatch<SetStateAction<boolean>>
 	setUsers:Dispatch<SetStateAction<User[]>>
 	users: User[];
 	setSelectedUser:Dispatch<SetStateAction<User>>;
	selectRef?: any;
	onChange?: any;
}

export interface User {
 	id: number;
 	first_name: string;
	middle_name: string;
 	last_name: string;
 	signed_in: boolean;
	active: boolean;
	photo: string;
	email: string;
	password: string;
	role: string;
}

export const FetchActiveUsers = async(setUsers: Dispatch<SetStateAction<User[]>>) => {
	try {
		const response = await fetch(process.env.REACT_APP_API+"/api/users")
		const results = await response.json()
		if (results) {
			setUsers(results)
		}
	} catch (error) {
		console.log(error)
	}
}

export const FetchDeletedUsers = async(setUsers: Dispatch<SetStateAction<User[]>>) => {
	try {
		const response = await fetch(process.env.REACT_APP_API+"/api/deletedUsers")
		const results = await response.json()
		if (results) {
			setUsers(results)
		} else {
			setUsers([])
		}
	} catch (error) {
		console.log(error)
	}
}

export const UserSelect = forwardRef(({ isVisible, setIsVisible, setUsers, users, setSelectedUser, onChange, selectRef}: UserSelectProps, ref: any) => {
	var userRef = ref;
	/* var selectRef = useRef<SelectInstance<Option |null>>(null) */
	interface Option {
		value: any;
		label: string;
	}
	const [options, setOptions] = useState<Option[]>([])

	const handleFocus= (value: any) => {
		if (selectRef.current) {
			selectRef.current.focus()
			userRef.current.value = value.value
		}
	}
	
 	const fetchCurrentUser = async() => {
 		try {
 			if (userRef && userRef.current) {
 				const userID = userRef.current.value
				if (userRef.current.value === "") {
					setIsVisible(false)
				} 
 				if (userID) {
 					const response = await fetch(process.env.REACT_APP_API+"/api/user?id=" + userID)
 					const result = await(response.json())
 					var user = result
					console.log(user)
 					setSelectedUser(user)
 				}
 			} 
 		} catch (error) {
 			console.log(error)
 		}
 	}

	const getUsersForSelect= () => {
		var options = [];
		for (var i = 0; i < users.length; i++) {
			var option = {
				value: users[i].id,
				label: users[i].first_name + " " + users[i].last_name
			}
			options.push(option)
		}
		setOptions(options)
	}

	const clearSelectedRef = () => {
		if (selectRef.current) {
			selectRef.current.blur()
		}
	}

	useEffect(() => {
		getUsersForSelect()
	}, [users])
 	
 	return (
 		<div className="resilire">
 			<label htmlFor="user">User</label>
			<Select ref={selectRef} className="resilire" options={options} onChange={(e) => {handleFocus(e); setIsVisible(true);fetchCurrentUser(); if (onChange) {onChange()}} } />
				
			<select id="user" name="user" ref={userRef} onChange={() => { setIsVisible(true); fetchCurrentUser(); if (onChange) { onChange(); } }} hidden>
				  <option value=""></option>
				  {users.map((user) => (
					  <option value={user.id} key={user.id}>{user.first_name} {user.middle_name} {user.last_name} </option>
				  ))}
			  </select>
		  </div>
 	)
})



